const coutryDeOther = [
  { label: 'Deutschland', value: 'DE' },
  { label: 'Anderes Land', value: 'OTHER' }
]

export default coutryDeOther
